import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'
import { RouteBreadCrumbs } from '../../routes';

import { App } from '../../App';
import { PaginatedList } from '../PaginatedList/PaginatedList'
import { StyledModal } from '../../styles/matieralui/Modal'
import { SmartContainer, Stack, StyledLeftSideBar } from '../../styles/Containers'
import { StyledButton } from '../../styles/matieralui/Button'
import { NewUserForm } from '../User/NewUserForm'

// Redux
import { FullAccount } from '../../redux/Account/account.selectors';
import { Role } from '../../redux/Auth/auth.selectors';
import { getTeamMembers } from '../../redux/Account/account.actions';
import { SettingsNavigation } from '../../capturecollab/components/Dashboard/SettingsNavigation';
import { Collapse } from '../Layout/Collapse';
import { Divider } from '@mui/material';
import { StyledB, StyledP } from '../../styles/StyledHTML';
import { TeamMate } from '../../capturecollab/components/Team/TeamMate';
import { setSpace, space } from '../../styles/Theme';
import { TERM_LIBRARY, TERM_LIBRARY_PLURAL } from '../../capturecollab/services/CaptureCollabService';





export const TeamPage = () => {

    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const fullAccount = FullAccount();
    const currentUserRole = Role();

    // Get Team List
    useEffect(() => { if (fullAccount.account?.id) dispatch(getTeamMembers(fullAccount.account.id, 1, 20)) }, [fullAccount.account])

    // Close Modal on Success
    useEffect(() => { if (fullAccount.addTeamMemberSuccess) { setOpenModal(false) } }, [fullAccount.addTeamMemberLoading])

    // On Select
    const handleUserClick = (user) => dispatch(push('/user/' + user.id));

    // Format Data
    const formattedTeam = (fullAccount.team) ? fullAccount.team.map(user => { return { id: user.id, title: `${user.firstName} ${user.lastName}`, description: user.role, full: user } }) : []

    const handleCloseModal = () => setOpenModal(false)

    const renderTopBarChildren = () => {

        if (currentUserRole === 'owner' || currentUserRole === 'admin') {
            return (
                <SmartContainer flex align="center" justify="flex-end">
                    <StyledButton variant="contained" color="pop" onClick={() => setOpenModal(true)}>Add A New User</StyledButton>
                </SmartContainer>
            )
        }

        return (<div />)

    }

    const renderTeam = (item, onClickItem) => (<TeamMate user={item?.full} onClick={onClickItem} />)

    return (
        <App title="Team" topBarChildren={renderTopBarChildren()}>

            <StyledLeftSideBar>
                <SettingsNavigation />
                <Stack>
                    <SmartContainer>
                        <StyledP><StyledB>Looking to share a {TERM_LIBRARY} with someone?</StyledB></StyledP>
                        <StyledP light>It's best to do that via the sharing settings on the {TERM_LIBRARY}. Adding team members here adds them to your account but doesn't grant them access to {TERM_LIBRARY_PLURAL}.</StyledP>
                    </SmartContainer>

                    {/* <Collapse title="Roles Explained" open={false}> */}
                    <SmartContainer>
                        <StyledP small><StyledB>Owner</StyledB></StyledP>
                        <StyledP small light>The owner is the highest level user. They can see all {TERM_LIBRARY_PLURAL} and manage the billing and team members.</StyledP>
                        <br />
                        <StyledP small><StyledB>Admin</StyledB></StyledP>
                        <StyledP small light>An Admin can manage everything except for the billing info. They can see all {TERM_LIBRARY_PLURAL} and add and remove team members.</StyledP>
                        <br />
                        <StyledP small><StyledB>Collaborator</StyledB></StyledP>
                        <StyledP small light>A Collaborator only has access to the {TERM_LIBRARY_PLURAL} that an Admin or Owner has granted them access to. They are able to view Assets in that {TERM_LIBRARY} as well as upload new one and edit existing ones.</StyledP>
                        <br />
                        <StyledP small><StyledB>Viewer</StyledB></StyledP>
                        <StyledP small light>A Viewer can only browse the {TERM_LIBRARY_PLURAL} that an Admin of Owner has granted them access to. They cannot comment or upload.</StyledP>
                    </SmartContainer>
                    {/* </Collapse> */}
                    <Divider />
                    <PaginatedList
                        onClickItem={handleUserClick}
                        loading={fullAccount?.teamLoading}
                        items={formattedTeam}
                        variant="cards"
                        noControls={true}
                        customRenderer={renderTeam}
                        columns={3}
                    />
                </Stack>
            </StyledLeftSideBar>


            {(currentUserRole === 'owner' || currentUserRole === 'admin') && (<StyledModal
                open={openModal}
                onClose={handleCloseModal}
                label="Add a new user"
                description="Create a new user on your account"
            >
                <NewUserForm />
            </StyledModal>)}
        </App>
    )
}